module.exports = __webpack_public_path__ + "img/plateImg1.4575d1e8.png";